/*
 * Layout for the authoring admin section
 */

define(["marionette", "./template/authoringAdminTemplate.html"], function (
  Marionette,
  AuthoringAdminTemplate,
) {
  var AuthoringAdminView = {
    authoringAdminLayout: Marionette.Layout.extend({
      template: AuthoringAdminTemplate,
      regions: {
        sideMenu: "#sideMenu",
        authoringAdmin: "#authoringAdmin",
      },
    }),
    triggers: {
      "click a": "click:menu",
    },
  };

  return AuthoringAdminView;
});
